import { ApiClient } from '../ApiClient';

export class GeneralApi {
  /**
   * @alias module:api/GeneralApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.generalApiInstance;
  }

  /**
   * Get current token price in USD
   */
  async getPrices() {
    return await this.apiClient.callApi('/prices', 'get', {}, {});
  }

  /**
   * Update NftContract metaStatus
   * @param {string} contractAddress Contract address of the NFT
   * @param {string} metaStatus New meta status value
   */
  async updateNftContractMetaStatus(contractAddress, metaStatus) {
    return await this.apiClient.callApi(
      '/collections/update-meta-status',
      'post',
      {},
      {},
      null,
      {},
      { contractAddress, metaStatus },
    );
  }
}
